module.exports = __webpack_public_path__ + "static/media/pause-in-circle.39145f96.svg";